import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AddressInfo,
  BackResponse,
  BackResponseFailure,
  BaseBackResponse,
  Intervention,
  WorkType,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}TechnicalIntervention`;

interface UpdateTechnicalInterventionCommandPayload {
  id: string;
  assignedToIds: string[];
  description: string;
  workTypeId?: string;
  ownerAddress?: AddressInfo;
  scheduleEndTimeUtc: Date;
  scheduleStartTimeUtc: Date;
  plannedStartTimeUtc?: Date;
  plannedEndTimeUtc?: Date;
  workType?: WorkType;
}

const updateTechnicalInterventionCommand = async (
  payload: UpdateTechnicalInterventionCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<Intervention>>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default updateTechnicalInterventionCommand;
